export default "__VITE_ASSET__BvKsdbDY__"